import { pick } from 'es-toolkit';
import React from 'react';
import { connect, ResolveThunks } from 'react-redux';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import { createPage } from '../../actions/documents';
import { RootState } from '../../store';

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ResolveThunks<typeof actionCreators>;
type Props = StateProps & DispatchProps;

function AddPage(props: Props) {
  const { activeDocumentId, activePageNumber } = props;
  return (
    <Tooltip disableInteractive disableFocusListener id="tooltip-icon" title="Add Page">
      <IconButton
        sx={{ borderRadius: 0, width: '100%' }}
        onClick={() => props.createPage(activeDocumentId!, activePageNumber + 1)}
        aria-label="Add Page"
      >
        <AddCircleIcon />
      </IconButton>
    </Tooltip>
  );
}

function mapStateToProps(state: RootState) {
  return pick(state.documents, ['activeDocumentId', 'activePageNumber']);
}

const actionCreators = {
  createPage,
};

export default connect(mapStateToProps, actionCreators)(AddPage);
